import { gridClasses } from '@rossum/ui/x-data-grid-pro';

const { columnHeader, columnHeaders, cell, footerContainer } = gridClasses;

export const drawerDataGridStyles = {
  backgroundColor: 'transparent',
  borderColor: 'transparent',
  [`& .${columnHeader}`]: {
    color: 'text.secondary',
    backgroundColor: 'transparent',
  },
  [`& .${cell} ,& .${columnHeaders} , & .${footerContainer}`]: {
    borderColor: 'transparent',
  },
};
